import { http, HttpResponse } from 'msw';

import { mockKbSession, sessionMock } from '../data/session';
import { resource } from '../helpers';

export const v3SessionHandler = [
    http.get(resource('/session'), () => {
        return HttpResponse.json(sessionMock);
    }),
];

export const v4SessionHandler = [
    http.get(resource('/session'), () => {
        return HttpResponse.json(mockKbSession);
    }),
];
